import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ParticipantRepository } from '@domain/participant/participant.repository';
import { Participant } from '@domain/participant/participant';
import { ParticipantResponseDto } from '../dtos/participant/participant.response.dto';
import { ParticipantMapper } from '../mappers/participant.mapper';

@Injectable()
export class ParticipantHttpRepository extends ParticipantRepository {
  private readonly baseUrl = `${environment.apiUrl}/participants`;
  private readonly dispositifUrl = `${environment.apiUrl}/dispositif`;

  constructor(private readonly http: HttpClient) { super(); }

  getAll(): Observable<Participant[]> {
    return this.http.get<ParticipantResponseDto[]>(this.baseUrl).pipe(
      map(dtos => dtos.map(dto => ParticipantMapper.fromDto(dto)))
    );
  }

  getByDispositifId(dispositifId: number): Observable<Participant[]> {
    return this.http.get<ParticipantResponseDto[]>(`${this.dispositifUrl}/${dispositifId}/participants`).pipe(
      map(dtos => dtos.map(dto => ParticipantMapper.fromDto(dto)))
    );
  }

  create(participant: Participant): Observable<Participant> {
    return this.http.post<ParticipantResponseDto>(this.baseUrl, ParticipantMapper.toRequestDto(participant)).pipe(
      map(dto => ParticipantMapper.fromDto(dto))
    );
  }

  update(participant: Participant): Observable<Participant> {
    return this.http.put<ParticipantResponseDto>(`${this.baseUrl}/${participant.id}`, ParticipantMapper.toRequestDto(participant)).pipe(
      map(dto => ParticipantMapper.fromDto(dto))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
